/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/payments",
    },
    (router) => {
      router.push({
        id: "@api/payment@create",
        path: "",
      });
      router.group(
        {
          path: "/:paymentId",
        },
        (router) => {
          router.push({
            id: "@api/payment@show",
            path: "",
          });
          router.push({
            id: "@api/payment@update",
            path: "",
          });
          router.push({
            id: "@api/payment@delete",
            path: "",
          });
          router.group(
            {
              path: "/downloads",
            },
            (router) => {
              router.push({
                id: "@api/payment@download-receipt",
                path: "/receipt",
              });
            },
          );
          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                path: "/sold",
                id: "@api/payment@sold",
              });
            },
          );
        },
      );
      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            path: "/configuration",
            id: "@api/payment@configuration",
          });
        },
      );
    },
  );
}
